fragment ProductWithoutVariationsFragment on ProductInterface {
    id

    type_id

    type {
        ...ProductTypeFragment
    }

    attributeValues {
        ...ProductAttributeValueFragment
    }

    categories {
        ...CategoryFragment
    }

    featured_media {
        ...MediaFragment
    }

    media {
        ...ProductMediaFragment
    }

    certificates {
        ...CertificateFragment
    }

    attachments {
        ...AttachmentWithPriorityFragment
    }

    tags {
        ...TagFragment
    }

    printAssignments {
        ...PrintAssignmentFragment
    }

    created_at
    updated_at

    status

    item_no

    name
    slug
    description

    supplier_id
}